module.exports = __webpack_public_path__ + "img/Logo-APAYM-PRO.2733d88e.png";